import React from 'react'
import { RegistrationFeature } from 'features/registration'
import { useParams } from 'react-router-dom'

export function RegistrationPage() {
  const { areaId } = useParams<{ areaId: string }>()
  return <RegistrationFeature areaId={areaId} />
}

